/*
 * $Id:: utils.js 2021/03/02 04:18 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import { Tooltip } from '@material-ui/core';
import { IconButton } from '@material-ui/core';

import ApplicationImage from '../../components/ApplicationImage';
import EllipsisSection from '../../components/ellipsisSection';
import ToolTip from '../../components/ToolTip/toolTip';
import NoImage from '../../components/NoImage';
import { ReactComponent as TooltipIcon } from '../../assets/images/tooltip_icon.svg';
import { t, bareDateTimeFormat } from '../../providers';

const TRADEMARKS = 'trademark';
const DESIGNS = 'design';
const PATENTS = 'patent';
const APPLICANT = 'Applicant';

const handleTrademarkType = (type) => t(type);

const handleTrademarkNiceClassification = (classifications) =>
    classifications.map((item, idx) => (
        <span key={idx} className={'classification-item'}>
            {item.classification}
        </span>
    ));

const handleDesignLocarnos = (locarnos) =>
    Object.values(locarnos).map((item, idx) => (
        <React.Fragment key={idx}>
            {item.mainClass && item.subClass ? (
                <span className={'classification-item'}>{`${item.mainClass}.${item.subClass}`}</span>
            ) : (
                t('not.available')
            )}
        </React.Fragment>
    ));

const handleClassifications = (classifications) => {
    return classifications.map((item, idx) => (
        <span className={'classification-item'} key={idx} style={{ paddingRight: '5px' }}>
            {item.classification}
        </span>
    ));
};

const handleClassificationsGrid = (classifications, requestNum, type) => {
    const tooltipIcon = <TooltipIcon aria-hidden="true" focusable="false" />;

    const tooltip = <ToolTip title={tooltipIcon} tooltipText={t('classification.toolip.text')} />;

    const items = (
        <>
            {classifications.map((item, idx) => (
                <span className={'classification-item'} key={idx} style={{ paddingRight: '5px' }}>
                    {item.classification}
                </span>
            ))}
            {tooltip}
        </>
    );

    return (
        <div className={'text-ellipsis classification-div'} id={`${requestNum}-${type}`}>
            {!!classifications.length ? (
                items
            ) : (
                <span className={'classification-noItem'} style={{ paddingRight: '5px' }}>
                    {t('not.available')}
                </span>
            )}
        </div>
    );
};

const handleTitles = (titles, att) => {
    let length = titles.length;
    return titles.map((item, idx) => (
        <span key={idx} style={{ paddingRight: '5px' }}>
            {item[att]}
            {idx < length - 1 ? ',' : null}
        </span>
    ));
};

const handleObjectArrays = (el, att) => {
    let value = el.map((item) => {
        if (item[att] !== null && item[att] !== 'undefined') {
            return `${item[att]}`;
        }
    });
    return longTextWithTooltip(value.join(','), '175px', 'three_rows');
};

const handleApplicants = (applicants, requestNum, type) => {
    let length = applicants.length;

    const items = applicants.map((item, idx) => {
        return `${item.name}${idx < length - 1 ? ',' : ''} `;
    });
    const elementId = `${requestNum}-${type}`;
    return createMoreLess(items, type, elementId);
};

const itemsLength = (applicants, maxlength, prop) => {
    let length = applicants.length;
    const items = applicants.map((item, idx) => {
        return item && item[prop] ? `${item[prop].trim()}${idx < length - 1 ? ',' : ''} ` : '';
    });
    return items.join().length > maxlength;
};

const createMoreLess = (items, type, elementId) => {
    return (
        <React.Fragment>
            <div id={elementId} className={'text-ellipsis'} aria-hidden="true" aria-labelledby={`btn-more-${elementId}`}>
                {items}
            </div>
        </React.Fragment>
    );
};

const handleShowMore = (e, elementId) => {
    const el = document.getElementById(elementId);
    const closestSpan = el.closest('span');
    const btnEl = e.currentTarget;
    if (el.classList.contains('text-noEllipsis')) {
        el.classList.remove('text-noEllipsis');
        el.classList.add('text-ellipsis');
        closestSpan.classList.remove('requestName');
        btnEl.textContent = ` + ${t('show.more.button.text')}`;
        btnEl.style.marginTop = '0px';
        btnEl.setAttribute('aria-expanded', false);
        el.setAttribute('aria-hidden', true);
    } else {
        el.classList.remove('text-ellipsis');
        el.classList.add('text-noEllipsis');
        closestSpan.classList.add('requestName');
        btnEl.textContent = ` - ${t('show.less.button.text')}`;
        btnEl.style.marginTop = '5px';
        btnEl.setAttribute('aria-expanded', true);
        el.setAttribute('aria-hidden', false);
    }
};

const handleIndicationsGrid = (indications, requestNum, type) => {
    let length = indications.length;
    let items = indications.map((item, idx) => `${item.product}${idx < length - 1 ? ',' : ''}`);

    const elementId = `${requestNum}-${type}`;
    return createMoreLess(items, type, elementId);
};

const handleIndications = (indications) => {
    let length = indications.length;
    return indications.map((item, idx) => (
        <span key={idx} style={{ paddingRight: '5px' }}>
            {item.product}
            {idx < length - 1 ? ',' : null}
        </span>
    ));
};

const parseTimestamp = (timestamp) => {
    let date = new Date(timestamp * 1);
    // Hours part from the timestamp
    // let hours = date.getHours();
    // // Minutes part from the timestamp
    // let minutes = "0" + date.getMinutes();
    // // Seconds part from the timestamp
    // let seconds = "0" + date.getSeconds();

    // // Will display time in 10:30:23 format
    // let formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
    return date;
};
const valueWithTooltip = (text, tooltipText) => (
    <Tooltip arrow title={tooltipText} placement={'top'} enterTouchDelay={0}>
        <span style={{ lineHeight: '27px' }}>{text}</span>
    </Tooltip>
);

const createLink = (text, linkPath) => {
    let link = linkPath ? (
        <IconButton
            disableFocusRipple
            className={'generalBtn'}
            role="link"
            aria-label={`${t('registration.number.link')} ${text}`}
            size="small"
            onClick={(e) => navigateTo(e, linkPath)}>
            {text}
        </IconButton>
    ) : (
        <span>{text}</span>
    );
    return link;
};

const navigateTo = (event, linkPath) => {
    event.preventDefault();
    if (!!linkPath) window.open(linkPath, '_blank');
};

const graphicalRepresentation = (application, category) => {
    const { type, denomination, graphicalRepresentation } = application;

    if (type === 'type.word') {
        return (
            <span
                style={{
                    fontSize: '1rem',
                    color: 'black',
                    fontFamily: '"Times New Roman", Times, serif',
                    textTransform: 'uppercase',
                    padding: '10px',
                    textAlign: 'center',
                }}>
                {denomination || ''}
            </span>
        );
    }
    return graphicalRepresentation ? (
        <ApplicationImage application={application} imageClass={'appImageGrid'} selectedTab={category} />
    ) : (
        <NoImage imageClass={'appImageGrid'} />
    );
};

const longTextWithTooltip = (text, elementWidth, className) => {
    return <EllipsisSection text={text} elementWidth={elementWidth} className={className} />;
};

const iconBtnMoreLess = (app, userType) => {
    return (
        <IconButton
            aria-label={t('show.more.about').replace('{requestNumber}', app.applicationNumber)}
            aria-expanded={false}
            id={`btn-more-${app.applicationNumber}-${userType}`}
            aria-controls={`${app.applicationNumber}-${userType}`}
            disableFocusRipple
            size="small"
            className={'more-less-btn'}
            onClick={(e) => handleShowMore(e, `${app.applicationNumber}-${userType}`)}>
            {` + ${t('show.more.button.text')}`}
        </IconButton>
    );
};

export const applicationsParserGrid = (applications, category, getApplicationReceipt, viewProcessDetails = () => {}) => {
    const { content } = applications;

    return (content || []).map((app) => {
        return {
            image: category.includes(TRADEMARKS) ? (
                graphicalRepresentation(app, category)
            ) : (
                <ApplicationImage application={app} imageClass={'appImageGrid'} selectedTab={category} />
            ),
            infoSection: [
                {
                    label: t('request.name'),
                    value: app.name ? (app.name === 'undefined' ? t('not.available') : t(app.name)) : t('not.available'),
                    extraClass: 'requestName',
                },
                {
                    label: t('request.number'),
                    value: app.applicationNumber
                        ? app.applicationNumber === 'undefined'
                            ? t('not.available')
                            : app.applicationNumber
                        : t('not.available'),
                },
                {
                    label: t('submission.date'),
                    value: (app.applicationFilingDate && bareDateTimeFormat(app.applicationFilingDate, 'dd/mm/YY', true)) || '',
                },
                {
                    label: t('request.status'),
                    value: app.applicationStatus
                        ? app.applicationStatus === 'undefined'
                            ? t('not.available')
                            : t(app.applicationStatus)
                        : t('not.available'),
                    extraClass: 'status',
                },
                {
                    label: t('request.status.date'),
                    value: (app.applicationStatusDate && bareDateTimeFormat(app.applicationStatusDate, 'dd/mm/YY', true)) || '',
                },
            ].filter((item) => typeof item === 'object'),
            details: [
                {
                    label: t('modality'),
                    value: app.modality ? (app.modality === 'undefined' ? t('not.available') : t(app.modality)) : t('not.available'),
                    extraClass: 'requestName',
                },
                {
                    label: t('registration.number'),
                    value: app.registrationNumber
                        ? app.registrationNumber === 'undefined'
                            ? t('not.available')
                            : createLink(app.registrationNumber, app.registrationLink)
                        : '',
                },
                category.includes(PATENTS) && {
                    label: t('title'),
                    value: app.titles && app.titles.length > 0 ? handleTitles(app.titles, 'name') : t('not.available'),
                },
                category.includes(DESIGNS) && {
                    label: t('number.of.products'),
                    value: app.numberOfProducts ? app.numberOfProducts : t('not.available'),
                },
                category.includes(DESIGNS) && {
                    label: t('indication.of.product'),
                    value:
                        app.indicationOfProducts && app.indicationOfProducts.length > 0
                            ? handleTitles(app.indicationOfProducts, 'product')
                            : t('not.available'),
                    extraClass: 'requestName',
                },
                category.includes(TRADEMARKS) && {
                    label: t('type'),
                    value: app.type ? (app.type === 'undefined' ? t('not.available') : handleTrademarkType(app.type)) : t('not.available'),
                    extraClass: 'requestName',
                },
                category.includes(TRADEMARKS) && {
                    label: t('denomination'),
                    value: app.denomination ? (app.denomination === 'undefined' ? t('not.available') : app.denomination) : '',
                    extraClass: 'requestName',
                },
                {
                    label: t('classification'),
                    value:
                        app.classifications && !!app.classifications.length
                            ? handleClassificationsGrid(app.classifications, app.applicationNumber, 'classification')
                            : t('not.available'),
                },
                {
                    label: t('registration.status'),
                    value: app.registrationStatus ? (app.registrationStatus === 'undefined' ? t('not.available') : t(app.registrationStatus)) : '',
                    extraClass: app.registrationStatus && app.registrationStatus !== 'undefined' ? 'status' : '',
                },
                {
                    label: t('decision.date'),
                    value: (app.decisionDate && bareDateTimeFormat(app.decisionDate, 'dd/mm/YY', true)) || '',
                },
                {
                    label: t('applicants.name'),
                    value:
                        app.applicants && app.applicants.length > 0
                            ? handleApplicants(app.applicants, app.applicationNumber, 'applicants')
                            : t('not.available'),
                    extraElement: itemsLength(app.applicants, 24, 'name') ? iconBtnMoreLess(app, 'applicants') : '',
                },
                {
                    label: t('representative.name'),
                    value:
                        app.representatives && app.representatives.length > 0
                            ? handleApplicants(app.representatives, app.applicationNumber, 'representatives')
                            : app.representatives && !app.representatives.length
                            ? ''
                            : t('not.available'),
                    extraElement: itemsLength(app.representatives, 24, 'name') ? (
                        iconBtnMoreLess(app, 'representatives')
                    ) : (
                        ''
                    ),
                },
                category.includes(DESIGNS) && {
                    label: t('designers.name'),
                    value:
                        app.designerInventors && app.designerInventors.length > 0
                            ? handleApplicants(app.designerInventors, app.applicationNumber, 'designers')
                            : app.designerInventors && !app.designerInventors.length
                            ? ''
                            : 'not.available',
                    extraElement: itemsLength(app.designerInventors, 24, 'name') ? (
                        iconBtnMoreLess(app, 'designers')
                    ) : (
                        ''
                    ),
                },
                category.includes(PATENTS) && {
                    label: t('inventor.name'),
                    value:
                        app.designerInventors && app.designerInventors.length > 0
                            ? handleApplicants(app.designerInventors, app.applicationNumber, 'inventors')
                            : app.designerInventors && !app.designerInventors.length
                            ? ''
                            : t('not.available'),
                    extraElement: itemsLength(app.designerInventors, 24, 'name') ? (
                        iconBtnMoreLess(app, 'inventors')
                    ) : (
                        ''
                    ),
                },
            ],
            menuItems: [
                // @TODO add actions to the menuItems
                {
                    label: t('view.application.receipt'),
                    action: () => getApplicationReceipt(app.applicationNumber, app.ipRightType, app.applicationStatus),
                },
                app.registrationLink && { label: t('view.process.details'), action: () => viewProcessDetails(app.registrationLink) },
            ].filter((item) => typeof item === 'object'),
        };
    });
};

export const applicationsParserList = (
    applications,
    category,
    userType,
    getApplicationReceipt,
    enableSorting = false,
    viewProcessDetails = () => {}
) => {
    const { content } = applications;

    let applicationsViewList = {
        headers: [
            { label: t('request.name'), code: 'requestName', align: 'left', sortable: enableSorting, style: { width: '15%' } },
            { label: t('request.number'), code: 'requestNumber', align: 'left', sortable: enableSorting, style: { width: '10%' } },
            { label: t('submission.date'), code: 'submissionDate', align: 'left', sortable: enableSorting, style: { width: '10%' } },
            { label: t('request.status'), code: 'requestStatus', align: 'left', sortable: enableSorting, style: { width: '10%' } },
            { label: t('modality'), code: 'modality', align: 'left', sortable: enableSorting, style: { width: '10%' } },
            category.includes(TRADEMARKS) && {
                label: t('denomination'),
                code: 'denomination',
                align: 'left',
                sortable: enableSorting,
                style: { width: '20%' },
            },
            category.includes(TRADEMARKS) && {
                label: t('design.graphicalRepresentation'),
                code: 'graphicalRepresentation',
                align: 'center',
                sortable: false,
                style: { width: '10%' },
            },
            category.includes(DESIGNS) && {
                label: t('number.of.products'),
                code: 'numberOfProducts',
                align: 'left',
                sortable: enableSorting,
            },
            category.includes(PATENTS) && {
                label: t('title'),
                code: 'titles',
                align: 'left',
                sortable: enableSorting,
            },
            category.includes(DESIGNS) && {
                label: t('indication.of.product'),
                code: 'indicationOfProducts',
                align: 'left',
                sortable: enableSorting,
            },
            { label: t('registration.status'), code: 'registrationStatus', align: 'left', sortable: enableSorting, style: { width: '10%' } },
            { label: t('registration.number'), code: 'registrationNumber', align: 'left', sortable: enableSorting },
            { label: t('my.applications.options.text'), code: 'actions', align: 'left', sortable: false },
        ].filter((item) => typeof item === 'object'), //remove non-objects from headers
    };

    let dataList = [];

    // table/list data
    const parsedApp = (content || []).map((app, idx) => [
        {
            label: t('request.name'),
            value: app.name
                ? app.name === 'undefined'
                    ? t('not.available')
                    : longTextWithTooltip(t(app.name), '193px', 'two_rows')
                : t('not.available'),
            style: { width: '20%' },
        },
        {
            label: t('request.number'),
            value: app.applicationNumber ? (app.applicationNumber === 'undefined' ? t('not.available') : app.applicationNumber) : t('not.available'),
            style: { width: '10%' },
        },
        {
            label: t('submission.date'),
            value: (app.applicationFilingDate && bareDateTimeFormat(app.applicationFilingDate, 'dd/mm/YY', true)) || '',
            style: { width: '10%' },
        },
        {
            label: t('request.status'),
            value: app.applicationStatus
                ? app.applicationStatus === 'undefined'
                    ? t('not.available')
                    : t(app.applicationStatus)
                : t('not.available'),
            style: { width: '10%' },
        },
        {
            label: t('modality'),
            value: app.modality
                ? app.modality === 'undefined'
                    ? t('not.available')
                    : longTextWithTooltip(t(app.modality), '120px', 'two_rows')
                : t('not.available'),
            style: { width: '10%' },
        },
        category.includes(TRADEMARKS) && {
            label: t('denomination'),
            value: app.denomination
                ? app.denomination === 'undefined'
                    ? t('not.available')
                    : longTextWithTooltip(app.denomination, '166px', 'three_rows')
                : '',
            style: { width: '15%' },
        },
        category.includes(TRADEMARKS) && {
            label: 'graphicalRepresentation',
            value: app.graphicalRepresentation ? (
                app.multimediaUrl ? (
                    <a href={app.multimediaUrl} target={'_blank'} rel="noopener noreferrer" style={{ height: '64px' }}>
                        <ApplicationImage application={app} selectedTab={category} />
                    </a>
                ) : (
                    <ApplicationImage application={app} selectedTab={category} />
                )
            ) : (
                <NoImage imageClass={'appImage'} />
            ),
        },
        category.includes(DESIGNS) && {
            label: 'number.of.products',
            value: app.numberOfProducts ? app.numberOfProducts : t('not.available'),
        },
        category.includes(PATENTS) && {
            label: 'title',
            value: app.titles && app.titles.length > 0 ? handleObjectArrays(app.titles, 'name') : t('not.available'),
        },
        category.includes(DESIGNS) && {
            label: t('indication.of.product'),
            value:
                app.indicationOfProducts && app.indicationOfProducts.length > 0
                    ? handleObjectArrays(app.indicationOfProducts, 'product')
                    : t('not.available'),
        },
        {
            label: t('registration.status'),
            value: app.registrationStatus
                ? app.registrationStatus === 'undefined'
                    ? t('not.available')
                    : longTextWithTooltip(t(app.registrationStatus), '193px', 'two_rows')
                : '',
            style: { width: '10%' },
        },
        {
            label: t('registration.number'),
            value: app.registrationNumber
                ? app.registrationNumber === 'undefined'
                    ? t('not.available')
                    : createLink(app.registrationNumber, app.registrationLink)
                : '',
            style: { width: '10%' },
        },
        {
            label: 'menuItems',
            value: [
                // @TODO add actions to the menuItems
                {
                    label: t('view.application.receipt'),
                    action: () => getApplicationReceipt(app.applicationNumber, app.ipRightType, app.applicationStatus),
                },
                app.registrationLink && { label: t('view.process.details'), action: () => viewProcessDetails(app.registrationLink) },
            ].filter((item) => typeof item === 'object'),
        },
    ]);

    //remove non-objects from data
    dataList = parsedApp.map((app) => {
        return app.filter((item) => typeof item === 'object');
    });

    applicationsViewList = {
        ...applicationsViewList,
        data: dataList,
    };

    return applicationsViewList;
};

export const filtersParser = (filters) => {
    const startDateTime = 'T00:00:00';
    const endDateTime = 'T23:59:59';
    let parsedFilters = { ...filters };
    // remove mark word from trademark types
    if (parsedFilters.types && parsedFilters.types.length > 0) {
        const parsedTypes = parsedFilters.types.map((item) => item.replace(' mark', ''));
        parsedFilters = { ...parsedFilters, types: parsedTypes };
    }

    // Normalize date ranges to API accepted date range data type, if any.
    if (parsedFilters.dates) {
        parsedFilters = {
            ...parsedFilters,
            dates: parsedFilters.dates.reduce((allDates, { dateType, startDate, endDate }) => {
                if (!!dateType && !!startDate && !!endDate) {
                    allDates.push({
                        date: dateType,
                        dateFrom: `${bareDateTimeFormat(startDate, 'YY-mm-dd')}${startDateTime}`,
                        dateTo: `${bareDateTimeFormat(endDate, 'YY-mm-dd')}${endDateTime}`,
                    });
                }
                return allDates;
            }, []),
        };
    }

    return parsedFilters;
};

export const myApplicationsExportColumns = (category) => {
    return [
        t('request.name'),
        t('request.number'),
        t('submission.date'),
        t('request.status'),
        t('request.status.date'),
        t('modality'),
        t('applicants.name'),
        t('representatives.name'),
        category.includes(TRADEMARKS) && t('type'),
        category.includes(TRADEMARKS) && t('denomination'),
        category.includes(DESIGNS) && t('number.of.products'),
        category.includes(PATENTS) && t('title'),
        t('classification'),
        category.includes(DESIGNS) && t('indication.of.product'),
        category.includes(DESIGNS) && t('designers.name'),
        t('registration.status'),
        t('registration.number'),
    ]
        .filter((item) => typeof item !== 'boolean')
        .map((colName) => colName.toUpperCase());
};
